<template>
<div>
    <div>
        <vs-table max-items="10" stripe search pagination :data="arrayDocumentosFacturacion">
            <template slot="header">
                <vs-chip color="primary">Cantidad: <b> {{ arrayDocumentosFacturacion.length }}</b></vs-chip>
            </template>
            <template slot="thead">
                <vs-th>Documento</vs-th>
                <vs-th>Cliente</vs-th>
                <vs-th>Fechas</vs-th>
                <vs-th>Acciones</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        # {{ tr.id }}<br>
                        {{data[indextr].ven_codigo}}<br>
                        <b>Período:</b>
                        <p>{{ tr.periodoescolar }}</p>
                        <b>Documento Bodega:</b>
                        <p>{{ tr.codigo_devolucion }}</p>
                        <b>Fecha creacion documento Bodega:</b>
                        <p>{{ tr.fecha_creacionPadre }}</p>
                        <b>Fecha de finalización documento Bodega:</b>
                        <p>{{ tr.fecha_finalizacionPadre }}</p>
                        <div v-if="tr.cantidadCodigos == '0'" class="mt-2" style="background-color: #e6a676; color: rgb(0, 0, 0);">
                            Documento sin códigos
                        </div>
                    </vs-td>
                    <vs-td>
                        {{data[indextr].nombreInstitucion}}<br><br>
                        <b>Empresa:</b>
                        <p> {{ tr.empresa }}</p>
                    </vs-td>
                    <vs-td>
                        <b>Fecha documento facturación:</b>
                        <p>{{ tr.created_at }}</p>
                        <b>Editor:</b>
                        <p>{{ tr.editor }}</p>
                    </vs-td>
                    <vs-td>
                        <!--boton para mostrar el documento facturación-->
                        <vs-button color="primary" @click="ObjectedSelected=tr;f_mostrarDetalles(tr);" type="filled">
                            Mostrar Detalles
                        </vs-button>
                        <!-- <vs-button type="line" @click="ObjectSelected=tr;popupMostrarTodosCodigos=true;" v-if="groupBodega" color="dark">
                            <i class="fa-solid fa-folder"></i> Mostrar todos los códigos
                        </vs-button> -->
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <!--modales-->
        <!--modal para mostrar los detalles del documento facturación-->
        <vs-popup classContent="popup-example" title="Mostrar detalles" :active.sync="popupMostrarDetalles" fullscreen>
            <div v-if="popupMostrarDetalles">
                <DevolucionDocumentosFacturacionDetallesVue :ObjectSelected="ObjectedSelected" :arrayCodigos="arrayDetalles" :procesoNuevo="procesoNuevo" :arrayDetallesAgrupados="arrayDetallesAgrupados" />
            </div>
        </vs-popup>
    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
const DevolucionDocumentosFacturacionDetallesVue = () => import("./DevolucionDocumentosFacturacionDetalles.vue");
import Generalmix from "../../../../../mixins/Generalmix";
export default {
    mixins: [Generalmix],
    components: {
        DevolucionDocumentosFacturacionDetallesVue
    },
    data() {
        return {
            arrayDocumentosFacturacion: [],
            ObjectedSelected: '',
            popupMostrarDetalles: false,
            procesoNuevo: 0,
            arrayDetallesAgrupados: [],
        }
    },
    computed: {
        ...mapState(['userRoot', 'groupFacturador', 'AdminBodega', 'groupBodega']),
    },
    mounted() {
        this.getDocumentosFacturacion();
    },
    methods: {
        getDocumentosFacturacion() {
            let me = this
            this.$http.get(this.$server_url + 'metodosGetDevolucionFacturador?getListadoDocumentosFacturador=1')
                .then(function (res) {
                    me.arrayDocumentosFacturacion = res.data;
                })
                .catch(function (error) {
                    console.log(error + ' error');
                })
        },
        f_mostrarDetalles() {
            let me = this
            var url = `metodosGetDevolucionFacturador?getFacturadorDocumentoDetalles=1&id_documento=${me.ObjectedSelected.id}`
            this.$http.get(this.$server_url + url)
                .then(function (res) {
                    me.arrayDetalles = res.data;
                    if (me.arrayDetalles.length == 0) {
                        me.m_message("No se encontro libros en el documento seleccionado", "warning")
                        return;
                    }
                    me.arrayDetalles.forEach((obj) => {
                        obj.subtotal = (obj.cantidad * obj.precio).toFixed(2);
                        obj.total = (obj.subtotal * (1 - obj.descuento / 100)).toFixed(2);
                    });

                    // Detectar proceso nuevo según periodo_id del documento padre
                    const periodoNuevoModulo = 29;
                    const periodo_id = me.ObjectedSelected.periodo_id != null ? me.ObjectedSelected.periodo_id : 0;
                    me.procesoNuevo = periodoNuevoModulo <= periodo_id ? 1 : 0;

                    // Agrupar por documento_venta + factura_perseo si proceso nuevo
                    if (me.procesoNuevo === 1) {
                        let docsMap = new Map();
                        me.arrayDetalles.forEach(item => {
                            const key = `${item.documento_venta || 'Sin Documento'}||${item.factura_perseo || 'Sin Factura'}`;
                            if (!docsMap.has(key)) {
                                docsMap.set(key, {
                                    documento_venta: item.documento_venta || 'Sin Documento',
                                    factura_perseo:  item.factura_perseo  || 'Sin Factura',
                                    items: []
                                });
                            }
                            docsMap.get(key).items.push(item);
                        });
                        me.arrayDetallesAgrupados = Array.from(docsMap.values()).map(grupo => ({
                            documento_venta: grupo.documento_venta,
                            factura_perseo:  grupo.factura_perseo,
                            arrayCodigos:    grupo.items,
                            subtotal: grupo.items.reduce((t, i) => t + parseFloat(i.subtotal || 0), 0),
                            total:    grupo.items.reduce((t, i) => t + parseFloat(i.total    || 0), 0),
                            cantidad: grupo.items.reduce((t, i) => t + parseFloat(i.cantidad || 0), 0),
                        }));
                    } else {
                        me.arrayDetallesAgrupados = [];
                    }

                    me.popupMostrarDetalles = true;
                })
                .catch(function (error) {
                    console.log(error + ' error');
                })
        },
    }
}
</script>
